import React, { Component } from "react"
import { Link } from "gatsby"

import {
  Collapse,
  NavItem,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
} from "reactstrap"

class NavBar extends Component {
  constructor(props) {
    super(props)
    this.toggle = this.toggle.bind(this)
    this.state = {
      isOpen: false,
    }
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    })
  }

  render() {
    const isActive = ({ isCurrent }) => {
      return isCurrent
        ? { className: "text-white nav-link navbar-link active" }
        : null
    }

    return (
      <header className="header-section">
        <div className="container">
          <Navbar className="my-navbar p-0 bg-black" dark expand="lg">
            <NavbarBrand href="/" className="logo">
              <img src={require("../../../static/logos/logo.png")} alt="" />
            </NavbarBrand>
            <NavbarToggler onClick={this.toggle} className="text-light" />
            <Collapse isOpen={this.state.isOpen} navbar>
              <Nav className="ml-auto" navbar>
                <NavItem className="pl-lg-4 pl-md-0 mt-lg-0 mt-md-4 nav-item-1-mt">
                  <Link
                    getProps={isActive}
                    className="text-white nav-link navbar-link"
                    to="/"
                  >
                    Home
                  </Link>
                </NavItem>
                <NavItem className="pl-lg-4 pl-md-0">
                  <Link
                    getProps={isActive}
                    className="text-white nav-link navbar-link"
                    to="/about-us"
                  >
                    About us
                  </Link>
                </NavItem>
                <NavItem className="pl-lg-4 pl-md-0">
                  <Link
                    getProps={isActive}
                    className="text-white nav-link navbar-link"
                    to="/services"
                  >
                    Services
                  </Link>
                </NavItem>
                <NavItem className="pl-lg-4 pl-md-0">
                  <Link
                    getProps={isActive}
                    className="text-white nav-link navbar-link"
                    to="/our-portfolio"
                  >
                    Portfolio
                  </Link>
                </NavItem>
                <NavItem className="pl-lg-4 pl-md-0">
                  <Link
                    getProps={isActive}
                    className="text-white nav-link navbar-link"
                    to="/blogs"
                  >
                    Blogs
                  </Link>
                </NavItem>
                <NavItem className="pl-lg-4 pl-md-0">
                  <Link
                    getProps={isActive}
                    className="text-white nav-link navbar-link"
                    to="/hire-us"
                  >
                    Hire
                  </Link>
                </NavItem>
                <NavItem className="pl-lg-4 pl-md-0">
                  <Link
                    getProps={isActive}
                    className="text-white nav-link navbar-link"
                    to="/contact-us"
                  >
                    Contact
                  </Link>
                </NavItem>
              </Nav>
            </Collapse>
          </Navbar>
        </div>
      </header>
    )
  }
}

export default NavBar
